module.exports = __webpack_public_path__ + "img/dunlop_white.5dcd0082.svg";